var Spinner = require("components/utility/Spinner");

class ReferralPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var redirectTitle = "Hang in there...";
		var imgPath = require("owls/default-owl-9.png");
		var redirectText = "You are being redirected...";

		var where = $wr.getURLParameterByName("where");
		if (where == "legacy") {
			redirectText = "";
		}
		var spinner = (<Spinner placeholder={ true } scale={ 1.5 } />);

		return (
			<div className="redirectPage">
				<header className="pageHeader">
					<h1>{ redirectTitle }</h1>
				</header>
				<div className="container text-center">
					{ spinner }
					<img src={ imgPath } />
					<p>{ redirectText }</p>
				</div>
			</div>
		);
	}
};

ReferralPage.propTypes = PageStrictPropTypes({
});

module.exports = ReferralPage;



// WEBPACK FOOTER //
// ./modules/components/technical/RedirectPage.js